import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "@emotion/styled";

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  cursor: ${(props) => props.cursor};
`;
